"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable */
/* tslint:disable */
var React = require("react");
var DatabaseSmall = function (_a) {
    var size = _a.size, props = __rest(_a, ["size"]);
    return (React.createElement("svg", __assign({ viewBox: "0 0 18 18", fill: "currentColor", width: size || "18", height: size || "18" }, props),
        React.createElement("path", { d: "M14,6.5 L14,12.5 C14,13.8807119 11.7614237,15 9,15 C6.23857625,15 4,13.8807119 4,12.5 C4,8.87527493 4,6.87527493 4,6.5 C4,5.11928813 6.23857625,4 9,4 C11.7614237,4 14,5.11928813 14,6.5 Z M9,9 C7.36440104,9 5.91222879,8.60732845 5,8.00024373 L5,9.50000007 C5,10.1399999 6.72000022,11 9,11 C11.2799998,11 13,10.1399999 13,9.5 L13,8.00024373 C12.0877712,8.60732845 10.635599,9 9,9 Z M9,12 C7.36440104,12 5.91222879,11.6073285 5,11.0002437 L5,12.5 C5,13.1399999 6.72000022,14 9,14 C11.2799998,14 13,13.1399999 13,12.5 L13,11.0002437 C12.0877712,11.6073285 10.635599,12 9,12 Z M9,8 C11.2799998,8 13,7.13999989 13,6.5 C13,5.86000011 11.2799998,5 9,5 C6.72000022,5 5,5.86000011 5,6.5 C5,7.13999989 6.72000022,8 9,8 Z" })));
};
DatabaseSmall.displayName = 'DatabaseSmall';
exports.default = DatabaseSmall;
/* tslint:enable */
/* eslint-enable */
//# sourceMappingURL=DatabaseSmall.js.map